import { mergeStyleSets } from '@fluentui/react';
import styled from 'styled-components';

export const modalStyles = mergeStyleSets({
  container: {
    display: 'flex',
    borderRadius: 16,
    width: 650,
    padding: '32px 16px',
    boxShadow: 'inset 0 6px 0 0 #FD6262, 1px 1px 8px rgba(0, 0, 0, 0.05)',
  },
});

export const SaveProjectModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  form {
    display: flex;
    flex-direction: column;

    button#saveProjectButton {
      display: flex;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
      border-radius: 1rem;
      margin: 0 auto;
      border: none;
      background: ${({ theme }: {theme: any}) => theme.themePrimary};
      color: #fff;
      font: 700 1rem/1rem 'Roboto', sans-serif;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: ${({ theme }: {theme: any}) => theme.themeDark};
      }
    }
  }

  label {
    font: 700 0.7rem/1rem 'Roboto', sans-serif;
    text-transform: uppercase;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
    margin-bottom: 0.5rem;
  }

  input {
    font: 400 0.9rem/1.1rem 'Roboto', sans-serif;
    display: flex;
    width: 100%;
    padding: 0.5rem;
    border: 1px solid ${({ theme }: {theme: any}) => theme.neutralLight};
    border-radius: 0.4rem;
    margin-bottom: 1rem;
    background: ${({ theme }: {theme: any}) => theme.neutralLighter};
    color: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const SaveProjectModalHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 20px 20px;
  align-items: center;

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
    white-space: nowrap;
  }

  h2 {
    border-left: 1px solid #dfdfdf;
    padding-left: 12px;
    font: 400 0.9rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }

  .closeModal {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`;

export const SaveProjectModalFooter = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
`;
